import Response from '../modules/classes/Response';

class RelationshipController {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async follow(targetId, targetType = 'user') {
    return new Promise((resolve, reject) => {
      const id = String(targetId || '').trim();
      const type = String(targetType || 'user').toLowerCase();
      if (!id) return reject(new Error('Missing targetId'));

      if (type === 'company') {
        this.apiService
          .post(`/company/${id}/follow`, {})
          .then((res) => resolve(Response.parse(res)))
          .catch((err) => reject(err));
        return;
      }

      if (type === 'user') {
        this.apiService
          .post(`/follow/${id}`, {})
          .then((res) => resolve(Response.parse(res)))
          .catch((err) => reject(err));
        return;
      }

      return reject(new Error(`Unsupported follow targetType: ${targetType}`));
    });
  }

  async unfollow(targetId, targetType = 'user') {
    return new Promise((resolve, reject) => {
      const id = String(targetId || '').trim();
      const type = String(targetType || 'user').toLowerCase();
      if (!id) return reject(new Error('Missing targetId'));

      if (type === 'company') {
        this.apiService
          .post(`/company/${id}/unfollow`, {})
          .then((res) => resolve(Response.parse(res)))
          .catch((err) => reject(err));
        return;
      }

      if (type === 'user') {
        this.apiService
          .delete(`/follow/${id}`)
          .then((res) => resolve(Response.parse(res)))
          .catch((err) => reject(err));
        return;
      }

      return reject(new Error(`Unsupported unfollow targetType: ${targetType}`));
    });
  }

  async viewProfile(targetId, targetType = 'user') {
    return new Promise((resolve, reject) => {
      const id = String(targetId || '').trim();
      const type = String(targetType || 'user').toLowerCase();
      if (!id) return reject(new Error('Missing targetId'));

      if (type === 'company') {
        this.apiService
          .post(`/company/${id}/view`, {})
          .then((res) => resolve(Response.parse(res)))
          .catch((err) => reject(err));
        return;
      }

      // Default: user profile view (if endpoint exists)
      this.apiService
        .post(`/users/${id}/view`, {})
        .then((res) => resolve(Response.parse(res)))
        .catch((err) => reject(err));
    });
  }

  async blockUser(blockedId) {
    return new Promise((resolve, reject) => {
      this.apiService.post(`/block/${blockedId}`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async muteUser(mutedId) {
    return new Promise((resolve, reject) => {
      this.apiService.post(`/mute/${mutedId}`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

export default RelationshipController;
